import { render, staticRenderFns } from "./embed_votes.vue?vue&type=template&id=2a70aa7c&scoped=true&"
import script from "./embed_votes.vue?vue&type=script&lang=js&"
export * from "./embed_votes.vue?vue&type=script&lang=js&"
import style0 from "./embed_votes.vue?vue&type=style&index=0&id=2a70aa7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70aa7c",
  null
  
)

export default component.exports